import { PORTALS_ACTIONS } from './portals.types'

/**
 *
 * @param {import('./portals.types').PortalsSlice['status']} payload
 * @returns {import('./portals.types').PortalsStatusAction}
 */
export const setPortalsStatusAction = payload => ({ type: PORTALS_ACTIONS.SET_PORTALS_STATUS, payload })

/**
 *
 * @param {import('../slice.types').SliceError} payload
 * @returns {import('./portals.types').PortalsErrorsAction}
 */
export const setPortalsErrorsAction = payload => ({ type: PORTALS_ACTIONS.SET_PORTALS_ERRORS, payload })

/**
 *
 * @param {import('./portals.types').PortalsSlice['task']} payload
 * @returns {import('./portals.types').PortalsTaskAction}
 */
export const setPortalsTaskAction = payload => ({ type: PORTALS_ACTIONS.SET_PORTALS_TASK, payload })

/**
 *
 * @param {import('./portals.types').Portal[]} payload
 * @returns {import('./portals.types').PortalsDataAction}
 */
export const setPortalsDataAction = payload => ({ type: PORTALS_ACTIONS.SET_PORTALS_DATA, payload })

/**
 * @param {import('./portals.types').PortalOption[]} payload
 * @returns {import('./portals.types').PortalOptionsAction}
 */
export const setPortalOptionsAction = payload => ({ type: PORTALS_ACTIONS.SET_PORTAL_OPTIONS, payload })

/**
 * @param {import('./portals.types').Portal} payload
 * @returns {import('./portals.types').PortalsAddAction}
 */
export const setPortalsAddAction = payload => ({
  type: PORTALS_ACTIONS.ADD_PORTAL,
  payload
})

/**
 * @param {Partial<import('./portals.types').Portal>} payload
 * @returns {import('./portals.types').PortalsUpdateAction}
 */
export const setPortalsUpdateAction = payload => ({
  type: PORTALS_ACTIONS.UPDATE_PORTAL,
  payload
})

/**
 * @param {number} payload
 * @returns {import('./portals.types').PortalsDeleteAction}
 */
export const setPortalsDeleteAction = payload => ({
  type: PORTALS_ACTIONS.DELETE_PORTAL,
  payload
})

/**
 * @returns {import('./portals.types').PortalsClearErrorsAction}
 */
export const clearPortalsErrorsAction = () => ({
  type: PORTALS_ACTIONS.CLEAR_PORTALS_ERRORS
})

/**
 * @returns {import('./portals.types').PortalsClearTaskAction}
 */
export const clearPortalsTaskAction = () => ({
  type: PORTALS_ACTIONS.CLEAR_PORTALS_TASK
})

/**
 * @returns {import('./portals.types').PortalsClearDataAction}
 */
export const clearPortalsDataAction = () => ({
  type: PORTALS_ACTIONS.CLEAR_PORTALS_DATA
})
